import React from "react"
import { Button, Tooltip } from "antd"
import { Moon, Sun, Monitor } from "react-feather"
import { getThemeMode, setThemeMode, ThemeMode } from "../../theme/theme"
import i18n from "../../services/i18n"

// Egasi (2026-09-02): «ba'zi razdellarda dark mode tugmasi yo'qolib qoladi» — tugma faqat jadval-sahifa
// sarlavhasida (Header.tsx) edi; umumiy sarlavha (HeaderHome.tsx) da yo'q edi. Endi bitta komponent, ikkala joyda.
export default function ThemeToggleButton() {
  const [mode, setMode] = React.useState<ThemeMode>(getThemeMode())
  const next: Record<ThemeMode, ThemeMode> = { light: "dark", dark: "system", system: "light" }
  const label: Record<ThemeMode, string> = {
    light: i18n.t("themeLightHint"),
    dark: i18n.t("themeDarkHint"),
    system: i18n.t("themeSystemHint"),
  }
  const icon = mode === "dark" ? <Moon /> : mode === "light" ? <Sun /> : <Monitor />
  return (
    <Tooltip placement="bottom" title={label[mode]}>
      <Button
        size="large"
        className="buttonHeader_r headermargin_r"
        icon={icon}
        onClick={() => {
          const m = next[mode]
          setThemeMode(m)
          setMode(m)
        }}
      />
    </Tooltip>
  )
}
